module.exports = __webpack_public_path__ + "static/img/9.e9afa25.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jzsg/9.png
// module id = UELy
// module chunks = 0